<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>visibility</mat-icon>
        <h1>{{'日次入退場状況：閲覧' | translate}}</h1>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content>

    <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

      <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

        <div>
          <label>{{'イベント' | translate}}</label>
          <div *ngIf="!!event && !!event.names">
            {{ event.names[0].name }}
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼入場口' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'通過人数' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!!daily && daily.entrances.length > 0">
              <tr *ngFor="let i = index; let transitCount of daily.entrances">
                <td>{{ i + 1 }}</td>
                <ng-container *ngFor="let entrance of event.entrances">
                  <td *ngIf="entrance.index === transitCount.id">{{ entrance.name }}</td>
                </ng-container>
                <td>{{ transitCount.count }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <br>
        <br>
        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼退場口' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'通過人数' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!!daily && daily.exits.length > 0">
              <tr *ngFor="let i = index; let transitCount of daily.exits">
                <td>{{ i + 1 }}</td>
                <ng-container *ngFor="let exit of event.exits">
                  <td *ngIf="exit.index === transitCount.id">{{ exit.name }}</td>
                </ng-container>
                <td>{{ transitCount.count }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>


      </div>

      <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

        <div>
          <label>{{'来場日' | translate}}</label>
          <div *ngIf="!!daily && daily.date">
            {{ daily.date.substring(0, 4) + '/' + daily.date.substring(4, 6) + '/' + daily.date.substring(6, 8) }}
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼展示' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'来場人数' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!!daily && daily.exhibits.length > 0">
              <tr *ngFor="let i = index; let transitCount of daily.exhibits">
                <td>{{ i + 1 }}</td>
                <ng-container *ngFor="let exhibit of exhibits">
                  <td *ngIf="exhibit.id === transitCount.id">{{ exhibit.exhibit_names[0].name }}</td>
                </ng-container>
                <td>{{ transitCount.count }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>


      </div>

    </div>


  </div>
</div>
